import React from 'react'
import PropTypes from 'prop-types'

import MasonryGrid from 'src/ui/MasonryGrid/MasonryGrid'
import { Box, Button } from '@chatterbug/aaron'
import Card from 'src/ui/Card/Card'
import ActivityLabel from 'src/ui/ActivityLabel/ActivityLabel'
import { t } from 'src/lib/i18n-react'

import UnitWritingPracticeListSkeleton from './UnitWritingPracticeListSkeleton'

// TODO: create a link styled like a button for use cases like this card
// TODO: take a closer look at the accessibility of the cards with buttons

const Content = (item) => {
  return (
    <Card
      label={<ActivityLabel type="writing" />}
      imgUrl={item.coverImageUrl}
      title={
        <Box
          sx={{
            // https://css-tricks.com/almanac/properties/l/line-clamp/
            display: '-webkit-box',
            '-webkit-line-clamp': '2',
            '-webkit-box-orient': 'vertical',
            overflow: 'hidden',
          }}
        >
          {item.name}
        </Box>
      }
      footer={
        <Button
          as="div"
          onClick={() => (window.location.href = item.entry.url)}
          type="primaryAdvanced"
          fill={item.hasEntry ? 'outline' : 'solid'}
          width="100%"
        >
          {item.hasEntry ? t('View entry') : t('Start writing')}
        </Button>
      }
    />
  )
}

const UnitWritingPracticeList = ({ items }) => {
  return (
    <UnitWritingPracticeListSkeleton
      titleSection={t('Writing Practices')}
      gridSection={<MasonryGrid items={items} renderGridContent={Content} />}
    />
  )
}

UnitWritingPracticeList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      hasWritingEntry: PropTypes.string.isRequired,
      writingEntryUrl: PropTypes.string.isRequired,
      coverImageUrl: PropTypes.string.isRequired,
    })
  ),
}

export default UnitWritingPracticeList
